import React, { FC, useState } from "react"

import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "@components/Button/Button"
import Modal from "@components/Modal/Modal"

import { QuestionListActionButtonsModalDIV, QuestionListActionButtonsRowDIV } from "./QuestionListActionButtons.styles"

import { GA_CUSTOM_EVENTS } from "../../../../_store/constants"
import { logCustomGAEvent } from "../../../../_utils"

type QuestionListActionButtonsProps = {
  onAddNewQuestion: () => void,
  onClickExport: () => void,
  onResetState: () => void,
}

const QuestionListActionButtons: FC<QuestionListActionButtonsProps> = ({
  onAddNewQuestion,
  onClickExport,
  onResetState,
}) => {
  const [showResetWarningModal, setShowResetWarningModal] = useState<boolean>(false)

  return (
    <>
      <QuestionListActionButtonsRowDIV>
        {/* Reset the state */}
        <Button
          onClick={() => {
            setShowResetWarningModal(true)
            logCustomGAEvent(GA_CUSTOM_EVENTS.SELECT_RESET_INTERVIEW, null)
          }}
          size={BUTTON_SIZES.S}
          variant={BUTTON_VARIANTS.SECONDARY}
        >
          Reset
        </Button>
        {/* Add a new question to the Interview */}
        <Button
          onClick={() => {
            onAddNewQuestion()
            logCustomGAEvent(
              GA_CUSTOM_EVENTS.ADD_QUESTION_TO_YOUR_INTERVIEW,
              null
            )
          }}
          size={BUTTON_SIZES.S}
          variant={BUTTON_VARIANTS.SECONDARY}
        >
          Add a Question
        </Button>
        {/* Export the PDF output */}
        <Button
          onClick={onClickExport}
          size={BUTTON_SIZES.S}
        >
          Export
        </Button>
      </QuestionListActionButtonsRowDIV>
      {showResetWarningModal && (
        <Modal
          hideCloseButton
          onClose={() => setShowResetWarningModal(false)}
        >
          {closeModal => (
            <QuestionListActionButtonsModalDIV>
              <p>Any changes you have made will be lost.<br />Are you sure you want to reset this interview?</p>
              <div>
                <Button
                  onClick={() => {
                    closeModal()
                    setShowResetWarningModal(false)
                  }}
                  variant={BUTTON_VARIANTS.SECONDARY}
                >
                  No, cancel
                </Button>
                <Button
                  onClick={() => {
                    onResetState()
                    closeModal()
                    setShowResetWarningModal(false)
                    logCustomGAEvent(
                      GA_CUSTOM_EVENTS.CONFIRM_RESET_INTERVIEW,
                      null
                    )
                  }}
                  variant={BUTTON_VARIANTS.WARNING}
                >
                  Yes, reset the interview
                </Button>
              </div>
            </QuestionListActionButtonsModalDIV>
          )}
        </Modal>
      )}
    </>
  )
}

export default QuestionListActionButtons
